import React, {Component} from 'react';
import StandardDropDown from './StandardDropDown';
import {View, Text, Image} from '@applane/react-core-components';
import {WithModal} from '@applane/react-with-modal';
import {getRenderComponent} from './Utility';

export class DropDownAction extends Component {
  renderModal = props => modalProps => {
    const {
      renderModal,
      dropdownStyle,
      title,
      titleStyle,
      renderDropDown,
      ...restProps
    } = props;
    if (renderModal) {
      return renderModal(modalProps);
    } else {
      let {frameStyle, hideModal} = modalProps;
      let dropdownProps = {
        ...restProps,
        closeModal: hideModal,
      };
      let dropdownComponent = getRenderComponent(renderDropDown, dropdownProps);
      if (!dropdownComponent) {
        dropdownComponent = <StandardDropDown {...dropdownProps} />;
      }
      return (
        <View
          style={{
            overflow: 'hidden',
            backgroundColor: '#ffffff',
            ...frameStyle,
            ...dropdownStyle,
          }}>
          {title && titleStyle && (
            <Text style={titleStyle}>{title}</Text>
          )}
          {dropdownComponent}
        </View>
      );
    }
  };

  render() {
    let {
      autoHide = true,
      position,
      style,
      backdropStyle,
      dropdownStyle,
      iconStyle,
      textStyle,
      activeTextStyle,
      icon,
      activeIcon,
      text,
      children,
      active,
      onModalShow,
      options,
      resolveVisible,
      ...restProps
    } = this.props;
    if (position && this.props[`${position}DropdownStyle`]) {
      dropdownStyle = this.props[`${position}DropdownStyle`];
    }
    if (active) {
      icon = activeIcon || icon;
    }
    if (!children) {
      children = (
        <View style={{flexDirection: 'row'}}>
          {icon ? <Image style={iconStyle} source={icon} /> : void 0}
          {text ? (
            <Text
              style={{
                ...textStyle,
                ...((active && activeTextStyle) || {}),
              }}>
              {text}
            </Text>
          ) : (
            void 0
          )}
        </View>
      );
    }
    if (options && options.length) {
      options = options.filter(_option => {
        if (!_option) {
          return;
        }
        let {visible = true} = _option || {};
        if (typeof visible === 'function') {
          if (resolveVisible) {
            visible = resolveVisible({...this.props, visible});
          } else {
            visible = visible(restProps);
          }
        }
        return visible;
      });
    }
    if (options && options.length) {
      return (
        <WithModal
          renderModal={this.renderModal({...restProps, options, dropdownStyle})}
          autoHide={autoHide}
          style={{...style, cursor: 'pointer'}}
          dropdownStyle={dropdownStyle}
          backdropStyle={backdropStyle}
          position={position}
          onModalShow={onModalShow}>
          {children}
        </WithModal>
      );
    } else {
      return <View style={style}>{children}</View>;
    }
  }
}

export default DropDownAction;
